export const toTwoDecimals = (value: number) => (value / 100).toFixed(2);